import { Component, Input } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ICON_TYPE } from '@spartacus/storefront'
import { VideoHost } from '../../../models/enum/video.enum'
import { Modal } from '../../../models/modal.model'

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {
  @Input() data: Modal
  iconType = ICON_TYPE
  videoHost = VideoHost
  constructor(
    public activeModal: NgbActiveModal,
    sanitizer: DomSanitizer
  ) {}
}
